export { default as component } from "../../../../src/routes/[prefix]/(feature)/customer-noo/+page.svelte";